import { Fab, Tooltip, Zoom, useTheme, useMediaQuery } from '@mui/material';
import { Add } from '@mui/icons-material';

interface CreateJobFABProps {
  onClick: () => void;
}

export function CreateJobFAB({ onClick }: CreateJobFABProps) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Zoom in>
      <Tooltip title="Create New Job" placement="left">
        <Fab
          color="primary"
          aria-label="create job"
          onClick={onClick}
          size={isMobile ? 'medium' : 'large'}
          sx={{
            position: 'fixed',
            bottom: isMobile ? 16 : 32,
            right: isMobile ? 16 : 32,
            boxShadow: '0 4px 20px rgba(228, 155, 61, 0.4)',
            '&:hover': {
              transform: 'scale(1.1)',
              boxShadow: '0 6px 24px rgba(228, 155, 61, 0.6)',
            },
            transition: 'all 0.3s ease',
          }}
        >
          <Add />
        </Fab>
      </Tooltip>
    </Zoom>
  );
}